(function($) {
  const $window = $(window);
  const $body = $(document.body);
  const $nav = $(".js-main-nav");

  let menuIsOpen = false;

  const isMobile = () => window.innerWidth <= 1024;
  const navHeight = () => (menuIsOpen ? window.innerHeight : 68) + "px";
  const position = () => (isMobile() ? "fixed" : "relative");
  const hasAdminBar = () => $body.hasClass("admin-bar");
  const top = () => (hasAdminBar() && isMobile() ? "46px" : 0);

  const css = () => ({
    position: position(),
    height: navHeight(),
    top: top()
  });

  const rightEdge = e => $(e).offset().left + $(e).width();

  const updateSubItems = () => {
    $(".c-navbar__sub-menu").each((i, e) => {
      if (rightEdge(e) > window.innerWidth) {
        $(e).css("right", "0");
      } else {
        $(e).css("right", null);
      }
    });
  };

  $body.on("click", ".js-toggle-nav", () => {
    menuIsOpen = !menuIsOpen;
    $body.toggleClass("menu-is-open", menuIsOpen);
    $nav.css(css());
  });

  $(window).on("resize", () => {
    $nav.css(css());
    updateSubItems();
  });

  updateSubItems();
})(jQuery);
